/* lua.js generated code 0.3.0 */
require("clover/data/ItemDataManager")
var UserDealPayTypeBase = require("clover/logic/userDeal/UserDealPayTypeBase")
var UserDealPayTypeCoin = xClass("UserDealPayTypeCoin", UserDealPayTypeBase)
UserDealPayTypeCoin.prototype.canBuyGoods = function (goodsId, num) {
    var self = this
    var goodsMeta = MetaManager.getInstance().getGoodsMeta(goodsId)
    if (goodsMeta.coin === 0) {
        // FIXME: multi result
        return [false, ZooErrorCode.BUY_WRONG_MONEY_TYPE]
    }
    if (UserCoin.getInstance().getAvaliableCoin() < goodsMeta.coin * num) {
        // FIXME: multi result
        return [false, ZooErrorCode.COIN_NOT_ENOUGH]
    }
    return [true,null]
}
UserDealPayTypeCoin.prototype.buyGoods = function (goodsId, num, targetId, param, successCallback, failCallback, cancelCallback) {
    var self = this
    var goodsMeta = MetaManager.getInstance().getGoodsMeta(goodsId)
    function onSuccess(event) {
        var user = UserManager.getInstance().getUserRef()
        UserCoin.getInstance().unlockCoin(goodsMeta.coin * num)
        UserCoin.getInstance().consumeCoin(goodsMeta.coin * num)
        if (successCallback) {
            successCallback(event)
        }
    }
    function onFail(event) {
        UserCoin.getInstance().unlockCoin(goodsMeta.coin * num)
        if (failCallback) {
            failCallback(event)
        }
    }
    function onCancel() {
        UserCoin.getInstance().unlockCoin(goodsMeta.coin * num)
        if (cancelCallback) {
            cancelCallback()
        }
    }
    UserCoin.getInstance().lockCoin(goodsMeta.coin * num)
    var http = BuyHttp.new()
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    let time = param ? param.time : null
    http.load(goodsId, num, 1, targetId,time)
}
/**
 * 检查是否可以购买Item
 */
UserDealPayTypeCoin.prototype.canBuyItem = function (itemId, num) {
    var self = this
    var itemData = ItemDataManager.getItemDataById(itemId)
    if (itemData.payType !== ItemDataManager.PayTypeEnum.Coin) {
        return [false, ZooErrorCode.BUY_WRONG_MONEY_TYPE]
    }
    if (UserCoin.getInstance().getAvaliableCoin() < itemData.price * num) {
        // FIXME: multi result
        return [false, ZooErrorCode.COIN_NOT_ENOUGH]
    }
    return [true, null]
}
/**
 * 购买Item
 */
UserDealPayTypeCoin.prototype.buyItem = function (itemId, num, successCallback, failCallback, cancelCallback) {
    var self = this
    var itemData = ItemDataManager.getItemDataById(itemId)
    function onSuccess(event) {
        var user = UserManager.getInstance().getUserRef()
        UserCoin.getInstance().unlockCoin(itemData.price * num)
        UserCoin.getInstance().consumeCoin(itemData.price * num)
        if (successCallback) {
            successCallback(event)
        }
    }
    function onFail(event) {
        UserCoin.getInstance().unlockCoin(itemData.price * num)
        if (failCallback) {
            failCallback(event)
        }
    }
    function onCancel() {
        UserCoin.getInstance().unlockCoin(itemData.price * num)
        if (cancelCallback) {
            cancelCallback()
        }
    }
    UserCoin.getInstance().lockCoin(itemData.price * num)
    var http = StartPanelBuyPropHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load(itemId, num)
}
module.exports = UserDealPayTypeCoin
